import React from 'react';
import PropTypes from 'prop-types';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import FieldAccordion from './FieldAccordion';

const propTypes = {
  fields: PropTypes.object,
};

function SectionFields({ fields }) {
  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }
    fields.move(result.source.index, result.destination.index);
  };

  const renderFieldAccordions = () => {
    return (
      <>
        {fields.map((name, index) => {
          const isDragDisabled = fields.length < 2;
          return (
            <Draggable
              key={name}
              draggableId={name}
              index={index}
              // disableInteractiveElementBlocking
              isDragDisabled={isDragDisabled}
            >
              {(draggableProvided, snapshot) => (
                <FieldAccordion
                  draggableProvided={draggableProvided}
                  snapshot={snapshot}
                  fieldIndex={index}
                  fieldName={name}
                  fields={fields}
                />
              )}
            </Draggable>
          );
        })}
      </>
    );
  };

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="section-accordion-droppable">
        {(droppableProvided) => (
          <div
            ref={droppableProvided.innerRef}
            {...droppableProvided.droppableProps}
          >
            {/* <AccordionSet> */}
            {renderFieldAccordions()}
            {droppableProvided.placeholder}
            {/* </AccordionSet> */}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
}

SectionFields.propTypes = propTypes;

export default SectionFields;
